import React, { useEffect, useState } from "react";
import { Checkbox, FormControlLabel, Box, FormControl, FormHelperText } from "@mui/material";

function MultiSelectCheckList({ apiCall, onChangeSelected, helperText = "" }) {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    apiCall().then((data) => {
      const updated = [{ id: "ALL", name: "Select All" }, ...data];
      setItems(updated);
    });
  }, [apiCall]);

  const handleToggle = (id) => {
    const allIds = items.filter((i) => i.id !== "ALL").map((i) => i.id);
    const isAllSelected = selected.length === allIds.length;

    let newSelected = [];

    if (id === "ALL") {
      newSelected = isAllSelected ? [] : allIds;
    } else {
      newSelected = selected.includes(id)
        ? selected.filter((v) => v !== id)
        : [...selected, id];
    }

    setSelected(newSelected);
    onChangeSelected?.(newSelected);
  };

  const getLabel = (item) => {
    if (item.id === "ALL") {
      const allIds = items.filter((i) => i.id !== "ALL").map((i) => i.id);
      const isAllSelected = selected.length === allIds.length;

      return isAllSelected ? "Deselect All" : "Select All";
    }
    return item.name;
  };

  return (
    <FormControl error={!!helperText} sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: .5,
          width: "100%",
        }}
      >
        {items.map((item) => (
          <Box
            key={item.id}
            sx={{
              flex: {
                xs: "0 0 100%",
                sm: "0 0 48%",
                md: "0 0 32%",
                lg: "0 0 24%",
              },
              display: "flex",
              alignItems: "center",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={
                    item.id === "ALL"
                      ? selected.length === items.filter((i) => i.id !== "ALL").length
                      : selected.includes(item.id)
                  }
                  indeterminate={
                    item.id === "ALL" &&
                    selected.length > 0 &&
                    selected.length < items.filter((i) => i.id !== "ALL").length
                  }
                  onChange={() => handleToggle(item.id)}
                />
              }
              label={getLabel(item)}
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: "14px",
                  wordBreak: "break-word",
                },
              }}
            />
          </Box>
        ))}
      </Box>

      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
}

export default MultiSelectCheckList;
